<template>
	<div class="register-wrapper">
		<div ref="form" class="weui-form__control-area">
			<div class="weui-cells__group weui-cells__group_form">
				<div class="weui-cells weui-cells_form">
					<div class="weui-cell weui-cell_active">
						<div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" v-model="registerForm.phonenumber" type="tel" maxlength="11"
								   required emptyTips="请输入手机号" placeholder="请输入手机号"/>
						</div>
						<!--<div class="weui-cell__ft">-->
							<!--<a class="weui-btn_reset weui-btn_icon">-->
								<!--<i id="showIOSDialog1" class="weui-icon-info-circle"></i>-->
							<!--</a>-->
						<!--</div>-->
					</div>
					<div class="weui-cell weui-cell_active weui-cell_vcode">
						<div class="weui-cell__hd"><label class="weui-label">验证码</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" v-model="registerForm.messageCode" type="tel"
								   required emptyTips="请输入验证码" placeholder="输入验证码" maxlength="6"/>
						</div>
						<div class="weui-cell__ft">
							<button class="weui-btn weui-btn_default weui-vcode-btn" @click="getCode">
								{{alreadySend ?'已发送 ' + second + ' S':'获取验证码'}}</button>
						</div>
					</div>
				</div>
				<!--<div class="weui-cells__tips"><a class="weui-link" href="javascript:">收不到验证码</a></div>-->
				<div class="weui-btn-area">
					<button class="weui-btn weui-btn_primary" @click="handleConfirm">确定</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { sendMes, register } from "../../../api/coupon/register";
	import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: "register",
		data () {
            return {
                alreadySend:false,
                second: 60,
                registerForm: {}
			}
		},
		computed: {
			...mapGetters(['userOpenid'])
		},
		methods: {
			...mapMutations({
                setUserPhone: "SET_USER_PHONE"
			}),
            /*验证输入框非空**/
            formValidate () {
                let form = this.$refs['form'];
                this.$weui.form.validate(form, error =>{
                    if (!error){
                        this.$set(this.registerForm,'openid',localStorage.getItem('userOpenId')||this.userOpenid);
                        register(this.registerForm).then(res =>{
							console.log(res,'12345697');
							if (res.code == 200){
							    this.setUserPhone(this.registerForm.phonenumber);
                                localStorage.setItem('userId',res.data.id);
                                let beforeUrl = localStorage.getItem("beforeUrl");
                                if (beforeUrl) {
                                    this.$router.push(beforeUrl);
                                } else {
                                    this.$router.push({name:'personalCenter'});
                                }
							}
                        })
                    }
                })
            },
            /* 获取验证码按钮操作**/
            getCode () {
                if (this.alreadySend){
                    return false
                }else {
                    if (this.registerForm.phonenumber) {
                        this.sendMsg()
					}else {
                        this.$weui.alert('请输入手机号')
					}

                }
			},
			sendMsg () {
              sendMes(this.registerForm.phonenumber).then(res =>{
                  if (res.code == 200) {
                      this.alreadySend = true;
                      this.timer();
				  }
			  })
			},
			timer () {
                let promise = new Promise((resolve, reject) => {
                    this.setTimer = setInterval(
                        () => {
                            this.second -= 1;
                            if (this.second <= 0) {
                                this.second = 60;
                                this.alreadySend = false;
                                resolve(this.setTimer)
                            }else {
                                this.alreadySend = true
                            }
                        }, 1000)
                });
                promise.then((setTimer) => {
                    clearInterval(setTimer)
                })
			},
			/*确认按钮操作**/
            handleConfirm () {
                let form = this.$refs["form"];
				this.formValidate(form)
			}
		}
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.weui-cells__group_form .weui-cell{
		padding: 16px;
	}
	.weui-btn-area{
		margin-top 20px
		 .weui-btn{
			 width: 100%;
		 }
		p{
			font-size $article-p
			color $article-merchant-p
			line-height 20px
			padding-top 10px
		}
	}
</style>
